import React from "react";
import useNamedSlots from "helpers/useNamedSlots";
import Spinner from "../Spinner";

// A Sub-Component for the title of the AboutUs component
const ViewsFilters = ({ children }) => <> {children} </>;
ViewsFilters.displayName = 'ViewsFilters';

// A Sub-Component for the description of the AboutUs component
const ViewsRows = ({ children }) => <> {children} </>;
ViewsRows.displayName = 'ViewsRows';
// A Sub-Component for the description of the AboutUs component
const ViewsHeader = ({ children }) => <> {children} </>;
ViewsHeader.displayName = 'ViewsHeader';

// A Sub-Component for the description of the AboutUs component
const ViewsFooter = ({ children }) => <> {children} </>;
ViewsFooter.displayName = 'ViewsFooter';

function View({ containerClass, loading, children }) {
  const slots = useNamedSlots(children, ['ViewsHeader', 'ViewsFilters', 'ViewsRows', 'ViewsFooter']);
  return (
    <div className={`react-view ${containerClass} ${loading ? 'loading' : ''}`}>
      <div className="react-view__header">{slots.ViewsHeader}</div>
      { slots.ViewsFilters && <div className="react-view__filters">{slots.ViewsFilters}</div> }
      <div className="react-view__rows">{slots.ViewsRows}</div>
      { slots.ViewsFooter && <div className="react-view__footer">{slots.ViewsFooter}</div> }
      { loading && <Spinner position='fixed' /> }
    </div>
  );
}

View.filters = ViewsFilters;
View.rows = ViewsRows;
View.header = ViewsHeader;
View.footer = ViewsFooter;

export default View;